import Breadcrumbs from 'components/Layout/Breadcrumbs/Breadcrumbs';
import { Webline } from 'components/Layout/Webline/Webline';
import useTranslation from 'next-translate/useTranslation';

export const ConfiguratorHeader = () => {
    const { t } = useTranslation();
    const breadcrumbs = [{ name: t('Configurator'), slug: '/configurator' }];

    return (
        <Webline>
            <Breadcrumbs key="breadcrumb" breadcrumb={breadcrumbs} />
            <div className="mb-1 mt-0 lg:w-desktop">
                <h1 data-testid="basic-heading-h1">{t('Configurator')}</h1>
            </div>
        </Webline>
    );
};
